// El botón blanco de las cards: «… sin preguntarme» —
// ADR-2026-09-13-generar-sin-preguntarme-en-la-card.
//
// Hace DOS cosas en un click: ejecuta la acción de la card (lo mismo que el botón
// primario) y deja el permiso puesto para las próximas. El permiso se cambia PRIMERO y
// de forma sincrónica: si la acción falla a mitad de camino, el usuario igual eligió lo
// que eligió, y si se cambiara después habría una ventana en la que el turno siguiente
// todavía lee el permiso viejo.
//
// El texto del botón sale de `permisoParaNoPreguntar`, no de un prop: en la card de
// productos el primario dice "Crear" y en la de investigación, "Activar". Un "Generar
// sin preguntarme" debajo de un "Crear" deja al usuario sin saber qué se está por hacer.

import React from 'react';
import { permisoParaNoPreguntar, type TipoAccion } from '../../../chat-atlas/confirmaciones';

export interface BotonGenerarSinPreguntarProps {
  /** Qué se está por hacer: decide el permiso que queda y el verbo del botón. */
  tipo: TipoAccion;
  /**
   * Apaga la confirmación de este tipo. `undefined` ⇒ el botón NO se dibuja: es lo que
   * pasa en el asistente legacy de `InterfazV2`, que no tiene permisos que cambiar.
   */
  noPreguntarMas?: (tipo: TipoAccion) => void;
  /** Lo mismo que hace el botón primario de la card. */
  onAccion: () => void;
  disabled?: boolean;
  className?: string;
}

export const BotonGenerarSinPreguntar: React.FC<BotonGenerarSinPreguntarProps> = ({
  tipo,
  noPreguntarMas,
  onAccion,
  disabled,
  className = '',
}) => {
  if (!noPreguntarMas) return null;
  const { etiqueta } = permisoParaNoPreguntar(tipo);
  return (
    <button
      type="button"
      onClick={() => {
        noPreguntarMas(tipo);
        onAccion();
      }}
      disabled={disabled}
      className={`mt-2 w-full rounded-2xl border border-neutral-200 bg-white py-2.5 px-5 text-[14px] font-semibold text-[rgb(var(--brand-black-rgb)_/_0.75)] transition-colors hover:bg-neutral-50 disabled:opacity-50 ${className}`}
    >
      {etiqueta}
    </button>
  );
};

export default BotonGenerarSinPreguntar;
